var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Survey, SurveyElementBase } from "survey-react-ui";
import * as React from "react";
var SurveySimulator = /** @class */ (function (_super) {
    __extends(SurveySimulator, _super);
    function SurveySimulator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SurveySimulator.prototype, "model", {
        get: function () {
            return this.props.model;
        },
        enumerable: false,
        configurable: true
    });
    SurveySimulator.prototype.getStateElement = function () {
        return this.model;
    };
    SurveySimulator.prototype.renderElement = function () {
        var _this = this;
        var mainSimulatorClass = this.model.getRootCss();
        if (!this.model.survey) {
            return React.createElement("div", { className: mainSimulatorClass });
        }
        if (this.model.hasFrame) {
            return (React.createElement("div", { className: mainSimulatorClass, onKeyDown: function (e) { return _this.model.tryToZoom(e, e); }, onMouseEnter: this.model.device === "desktop" ? null : this.model.activateZoom, onMouseLeave: this.model.device === "desktop" ? null : this.model.deactivateZoom },
                React.createElement("div", { className: "svd-simulator-wrapper", id: "svd-simulator-wrapper", style: {
                        width: this.model.simulatorFrame.frameWidth + "px",
                        height: this.model.simulatorFrame.frameHeight + "px"
                    } },
                    React.createElement("div", { className: "svd-simulator", style: {
                            width: this.model.simulatorFrame.deviceWidth + "px",
                            height: this.model.simulatorFrame.deviceHeight + "px",
                            transform: "scale(" +
                                this.model.simulatorFrame.scale +
                                ") translate(-50%, -50%)"
                        } },
                        React.createElement("div", { className: "svd-simulator-content" },
                            React.createElement(Survey, { model: this.model.survey }))))));
        }
        else {
            return (React.createElement("div", { className: mainSimulatorClass },
                React.createElement("div", { className: "svd-simulator-content" },
                    React.createElement(Survey, { model: this.model.survey }))));
        }
    };
    return SurveySimulator;
}(SurveyElementBase));
export { SurveySimulator };
